import Image from 'next/image'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { BannerImageProps } from './types'

const BannerImage = ({ urlString }: BannerImageProps): JSX.Element => {
  return (
    <Image
      src={publicAssetUrl(`${urlString}.webp`)}
      alt={`${urlString}`}
      width={496}
      height={500}
    />
  )
}

export default BannerImage
